import Main from './Main.vue'
import Lista from './components/ListaGrvs'
import Grv from './components/Grv'
import GrvPatio from './components/GrvPatio'
// import ModificarGgv from './components/ModificarGgv'

export default [{
  path: 'grv',
  name: 'grv',
  component: Main,
  children: [
    {path: '/', component: Lista, name: 'grv'},
    {path: 'registrar', component: Grv, name: 'grv.novo'},
    {path: ':id', component: Grv, name: 'grv.visualizar'},
    {path: 'patio/:id', component: GrvPatio, name: 'grv.visualizar.patio'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/grvs/routes.js